<template>
  <v-col class="col-12">
    <v-container fill-height>
      <v-row no-gutters align="center">
        <span class="title">Questionnaires</span>
        <v-spacer></v-spacer>
        <v-btn small icon @click="ctrl.onAdd()">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-row>

      <v-row>
        <v-col
          cols="3"
          xs="6"
          sm="6"
          md="3"
          lg="3"
          xl="3"
          v-for="(item, idx) in ctrl.list"
          :key="idx"
          style="text-align: center; text-justify: center"
        >
          <g-list-card
            :header="item.title"
            :subHeader="item.name"
            :item="item"
            controller="questionnaire"
            :addContentTt="addContentTt"
            :editTt="editTt"
            :deleteTt="deleteTt"
          />
        </v-col>
      </v-row>

      <confirmation-dialog ref="confirmationDialog" />
    </v-container>
  </v-col>
</template>

<script>
export default {
  data() {
    return {
      addContentTt: "Add Questionnaire Content",
      editTt: "Edit Questionnaire",
      deleteTt: "Delete Questionnaire",
      ctrl: this.get_controller("questionnaire"),
    };
  },
  mounted() {
    this.ctrl.getAll();
  },
};
</script>

<style scoped>
.hiddenText {
  color: #51cae9;
}

#sub-card {
  min-height: 250px;
  width: 100%;
  background: #51cae9;
  border-radius: 30px;
  box-shadow: 3px 0px 6px rgba(0, 0, 0, 0.15);
  position: relative;
  text-align: center;
}
</style>